import { CiSquareRemove } from "react-icons/ci";
import { useTranslation } from "react-i18next";

export const RestaurantDetailsModal: React.FC<{
  restaurant: any;
  onClose: () => void;
}> = ({ restaurant, onClose }) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white py-6 w-[1104px] px-14 h-[522px]">
        <div className="flex justify-end w-full mb-8">
          <button onClick={onClose}>
            <CiSquareRemove size={24} />
          </button>
        </div>
        <h1 className="text-xl font-medium">{t("restaurantdetails.title")}</h1>
        <div className="flex gap-4 mt-3">
          <div className="w-6/12">
            <label className="text-sm font-medium">
              {t("restaurantdetails.restaurantName")}
            </label>
            <p className="text-sm border-b w-[474px] py-2 px-2">
              {restaurant?.name}
            </p>
          </div>
          <div className="w-6/12">
            <label className="text-sm font-medium">
              {t("restaurantdetails.emailAddress")}
            </label>
            <p className="text-sm border-b w-[474px] py-2 px-2">
              {restaurant?.emailAddress}
            </p>
          </div>
        </div>
        <div className="flex gap-4 mt-8">
          <div className="w-6/12">
            <label className="text-sm font-medium">
              {t("restaurantdetails.restaurantLogo")}
            </label>
            <p className="text-sm border-b w-[474px] px-2">
              <img
                src={restaurant?.logoUrl}
                alt="logo"
                className="h-[36px] w-[40px]"
              />
            </p>
          </div>
          <div className="w-6/12">
            <label className="text-sm font-medium">
              {t("restaurantdetails.openingHours")}
            </label>
            <p className="text-sm border-b w-[474px] py-2 px-2">
              {restaurant?.openingHours}
            </p>
          </div>
        </div>
        <div className="flex gap-4 mt-8">
          <div className="w-6/12">
            <label className="text-sm font-medium">
              {t("restaurantdetails.ownerName")}
            </label>
            <p className="text-sm border-b w-[474px] py-2 px-2">
              {restaurant?.ownerName}
            </p>
          </div>
          <div className="w-6/12">
            <label className="text-sm font-medium">
              {t("restaurantdetails.ownerEmail")}
            </label>
            <p className="text-sm border-b w-[474px] py-2 px-2">
              {restaurant?.ownerEmail}
            </p>
          </div>
        </div>
        <div className="flex gap-4 mt-8">
          <div className="w-6/12">
            <label className="text-sm font-medium">
              {t("restaurantdetails.location")}
            </label>
            <p className="text-sm border-b w-[474px] py-2 px-2">
              {restaurant?.location}
            </p>
          </div>
          <div className="w-6/12">
            <label className="text-sm font-medium">
              {t("restaurantdetails.phoneNumber")}
            </label>
            <p className="text-sm border-b w-[474px] py-2 px-2">
              {restaurant?.phoneNumber}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
